let pauses = 0;
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((listener) => listener());

export function pauseBackgroundAnimations(): () => void {
  pauses += 1;
  notify();

  let released = false;

  return () => {
    if (released) return;
    released = true;
    pauses -= 1;
    notify();
  };
}

export const areBackgroundAnimationsPaused = () => pauses > 0;

export function subscribeBackgroundAnimations(listener: () => void) {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}
